module.exports = __webpack_public_path__ + "static/media/Resume (2).fc9dc010.pdf";